/* V4 native-store helpers. No cart, customer, analytics or remote AI writes. */
(() => {
 'use strict';
 if (window.__patinaV4Native) return;
 window.__patinaV4Native=true;
 const clean=v=>String(v||'').replace(/[\u0000-\u0008\u000b\u000c\u000e-\u001f]/g,'').slice(0,500);
 function initialize(scope=document){
  const reference=clean(new URLSearchParams(location.search).get('reference'));
  if(reference)scope.querySelectorAll('[data-ps4-contact-reference]').forEach(field=>{if(!field.value)field.value=reference;});
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initialize(),{once:true});else initialize();
 document.addEventListener('shopify:section:load',event=>initialize(event.target));
})();
